module.exports = __webpack_public_path__ + "static/media/erip.b8fef107.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/payment-systems/erip.png
// module id = 532
// module chunks = 0